export const server = "https://pj-dealingreport-mt5-api-uat.agile168.com/";
export const days = 2;



// WEBPACK FOOTER //
// ./src/api/env.js